"use client";

import { usePathname } from "next/navigation";
import { RefObject, useEffect } from "react";

/**
 * 路由变化时自动滚动到页面顶部
 * @param ref 可选的 DOM 元素引用，如果提供则滚动该元素，否则滚动 window
 */
export function useScrollTopOnNav<T extends HTMLElement | null>( ref?: RefObject<T> ) {
    const pathname = usePathname();

    useEffect( () => {
        if ( ref?.current ) {
            ref.current.scrollTo( 0, 0 );
        } else {
            window.scrollTo( 0, 0 );
        }
    }, [ pathname, ref ] );
}
